module.exports = __webpack_public_path__ + "static/img/zhongzi.755f055f.svg";